<h1 class="text-2xl md:text-3xl font-bold text-gray-900">Welcome!</h1>
<p class="text-gray-500 mt-1 mb-4">You are almost ready to start automating.</p>
<p class="mb-6">
  <span class="inline-block py-1 px-3 bg-primary-50 text-primary-700 border border-primary-200 rounded-full text-sm">
    {{email.value}}
  </span>
</p>

<form [formGroup]="welcomeForm">
  <div class="dm-input">
    <label>Name</label>
    <input formControlName="name" type="text" placeholder="Jane Doe">
    <small class="red" *ngIf="name.touched && name.invalid">Cannot be empty</small>
  </div>
  <div class="dm-input">
    <label>Password</label>
    <input formControlName="password" type="password" placeholder="••••••••">
    <small class="red" *ngIf="password.touched && password.invalid">Cannot be empty</small>
  </div>

  <button (click)="onLogin()" *ngIf="!processing" class="btn btn-primary w-full" type="button">Continue</button>
  <button disabled class="btn btn-processing w-full" type="button" *ngIf="processing">
    <i class="fas fa-circle-notch"></i>
    Please wait...
  </button>

  <app-warning-message type="error" title="Sign in failed" message="Wrong email or password."
                        *ngIf="authSvc.invalidEmail || authSvc.wrongCredentials || authSvc.userNotFound"></app-warning-message>
  <app-warning-message type="error" title="Too many attempts" message="We have detected too many failed attempts. Wait a few minutes and try again."
                        *ngIf="authSvc.tooManyRequests"></app-warning-message>
  <app-warning-message type="error" title="Something went wrong" [message]="authSvc.unknownError"
                        *ngIf="authSvc.unknownError"></app-warning-message>
</form>

<div class="divider-new version-2 my-6 text-gray-500 flex items-center justify-center flex-row">
  <h6 class="small mx-2">OR</h6>
</div>

<div class="flex flex-col gap-3">
  <app-social-signin-button provider="google" label="Continue with Google" (clicked)="authSvc.loginWithSocial('google.com')"></app-social-signin-button>
  <app-social-signin-button provider="microsoft" label="Continue with Microsoft" (clicked)="authSvc.loginWithSocial('microsoft.com')"></app-social-signin-button>
</div>

<p class="text-sm text-gray-500 mt-8 text-center">
  <span class="mr-1">Don't have an account?</span>
  <a class="basic-link font-medium" routerLink="../signup">Create free account</a>
</p>
